// @flow
import React from 'react'
import { Waypoint } from 'react-waypoint'
import './styles.scss'

const isMobile = window.innerWidth < 600

export class Person extends React.Component<Props, State> {
  constructor() {
    super()
    this.state = {}
  }

  handleWaypointEnter = (e, which) => {
    let what = 'enter'
    if (e.currentPosition == 'inside' && e.previousPosition === 'below') {
      what = 'enter_from_bottom'
      if (which === 'top') {
        console.log('top:', this.props.id)
        this.props.setCurrent(this.props.id)
      }
    }
    if (e.currentPosition == 'inside' && e.previousPosition === 'above') {
      what = 'enter_from_top'
      if (which === 'bottom') {
        console.log('bottom:', this.props.id)
        this.props.setCurrent(this.props.id)
      }
    }
  }

  componentDidMount() {}

  render() {
    return (
      <div
        id={this.props.id}
        className='ui text person container'
        style={
          this.props.bottomMargin !== ''
            ? { marginBottom: this.props.bottomMargin }
            : {}
        }
      >
        <Waypoint
          onEnter={e => {
            this.handleWaypointEnter(e, 'top')
          }}
        />
        <div className='ta text'>
          <div className='img-wrapper'>
            <img className='ui image fluid' src={this.props.img} />
          </div>
          <p className='quote'>
            <span className='mark'>«</span>
            {this.props.quote}
            <span className='mark'>»</span>
          </p>
          <div className='info'>{this.props.info}</div>
          <div className='hr-theme-slash-2'>
            <div className='hr-line' />
          </div>
          {this.props.children}
        </div>
        <Waypoint
          onEnter={e => {
            this.handleWaypointEnter(e, 'bottom')
          }}
          topOffset={'600px'}
          bottomOffset={'600px'}
        />
      </div>
    )
  }
}
